var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.031,
    height: 24.285,
    viewBox: "0 0 28.031 24.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2434",
    "data-name": "Group 2434",
    transform: "translate(-3172.3 -483.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M3188.116,535.984h0a2.208,2.208,0,0,1,0-3.111l3.658-3.658a2.208,2.208,0,0,1,3.111,0h0a2.208,2.208,0,0,1,0,3.111l-3.658,3.658A2.208,2.208,0,0,1,3188.116,535.984Z",
    transform: "translate(-11.461 -34.967)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_299",
    "data-name": "Line 299",
    x2: 3.111,
    y2: 3.111,
    transform: "translate(3178.495 496.067)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M3227.576,514.358V508.51a2.39,2.39,0,0,0-.569-1.555L3224.4,503.8",
    transform: "translate(-40.297 -15.619)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M3175.976,503.7l-2.607,3.154a2.39,2.39,0,0,0-.57,1.555v11.741a2.449,2.449,0,0,0,2.453,2.453h9.551a2.338,2.338,0,0,0,1.227-.329",
    transform: "translate(0 -15.541)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M3187.835,488.159h-9.923a1.514,1.514,0,0,1-1.511-1.511v-1.336a1.514,1.514,0,0,1,1.511-1.511h9.923a1.514,1.514,0,0,1,1.511,1.511v1.336A1.514,1.514,0,0,1,3187.835,488.159Z",
    transform: "translate(-2.812 0)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849",
    transform: "translate(3177.816 485.136)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_300",
    "data-name": "Line 300",
    y2: 1.577,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_301",
    "data-name": "Line 301",
    y2: 1.577,
    transform: "translate(2.234 0)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_302",
    "data-name": "Line 302",
    y2: 1.577,
    transform: "translate(4.469 0)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M3245.909,560.363c-.964.635-2.563,1.227-5.454,1.227-3.023,0-5.454-1.029-5.454-2.3,0-.57.482-1.073,1.292-1.49",
    transform: "translate(-48.575 -57.79)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M3245.909,579.6c0,1.271-2.454,2.3-5.454,2.3-3.023,0-5.454-1.03-5.454-2.3",
    transform: "translate(-48.575 -74.815)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_303",
    "data-name": "Line 303",
    y1: 2.212,
    transform: "translate(3197.334 502.573)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_304",
    "data-name": "Line 304",
    y1: 3.308,
    transform: "translate(3186.425 501.478)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 5.454,
    cy: 2.3,
    rx: 5.454,
    ry: 2.3,
    transform: "translate(3188.923 493.679)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M3256.774,536.872a6.754,6.754,0,0,1-4.075-.986,6.923,6.923,0,0,1,4.075-.986,6.75,6.75,0,0,1,4.074.986A6.92,6.92,0,0,1,3256.774,536.872Z",
    transform: "translate(-62.397 -39.906)",
    fill: "#ffc524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M3257.309,554.5c0,1.271-2.453,2.3-5.455,2.3-3.023,0-5.454-1.03-5.454-2.3",
    transform: "translate(-57.478 -55.213)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_305",
    "data-name": "Line 305",
    y1: 3.308,
    transform: "translate(3199.831 495.979)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    y1: 3.308,
    transform: "translate(3188.923 495.979)",
    fill: "none",
    stroke: "#756583",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/Bottle.dd44ebdcfeee96977483d48dac28e73f.svg";
export { ForwardRef as ReactComponent };